import { Download } from "lucide-react";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n";
export function DownloadButton({ sizeMb }: { sizeMb?: string }) {
  const { t } = useI18n();
  return (
    <Link className="button primary large cta-download" to="/download">
      <Download size={17} aria-hidden />
      <span className="cta-text">
        <strong>{t("home.ctaDownload")}</strong>
        <small>
          {sizeMb
            ? t("home.ctaDownloadMeta", { size: sizeMb })
            : t("home.ctaDownloadMetaNoSize")}
        </small>
      </span>
    </Link>
  );
}
export function DownloadSection({ sizeMb }: { sizeMb?: string }) {
  const { t } = useI18n();
  return (
    <section className="home-final" aria-labelledby="home-download-title">
      <div className="container home-download-section">
        <div className="stack">
          <h2 id="home-download-title">{t("home.finalTitle")}</h2>
          <p>
            {sizeMb
              ? t("home.finalText", { size: sizeMb })
              : t("home.finalTextNoSize")}
          </p>
        </div>
        <div className="home-download-actions">
          <DownloadButton sizeMb={sizeMb} />
          <Link className="button ghost" to="/requirements">
            {t("home.ctaRequirements")}
          </Link>
        </div>
      </div>
    </section>
  );
}
